import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chitfund',
  templateUrl: './chitfund.component.html',
  styleUrls: ['./chitfund.component.css']
})
export class ChitfundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/chitfund/chitfund.component.ts